import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const styles = [
  {
    name: 'Korean Minimal',
    slug: 'Korean+Minimal',
    image: 'https://readdy.ai/api/search-image?query=Tiny%20gold%20ball%20studs%20and%20delicate%20chain%20on%20warm%20beige%20background%2C%20korean%20minimal%20aesthetic%2C%20clean%20simple%20jewellery%2C%20soft%20lighting%2C%20editorial%20product%20photography&width=600&height=600&seq=style-korean-min&orientation=squarish',
  },
  {
    name: 'Multi-Layered',
    slug: 'Multi-Layered',
    image: 'https://readdy.ai/api/search-image?query=Three%20gold%20chain%20necklaces%20layered%20together%20on%20blush%20background%2C%20textured%20styling%2C%20warm%20editorial%20lighting%2C%20premium%20jewellery%20flat%20lay%20photography&width=600&height=600&seq=style-multilayer&orientation=squarish',
  },
  {
    name: 'Pearl-Accent',
    slug: 'Pearl-Accent',
    image: 'https://readdy.ai/api/search-image?query=Gold%20earrings%20and%20necklace%20with%20white%20pearl%20accents%20on%20blush%20background%2C%20elegant%20minimal%20jewellery%2C%20soft%20warm%20lighting%2C%20premium%20product%20photography&width=600&height=600&seq=style-pearl&orientation=squarish',
  },
  {
    name: 'Charm / Personalised',
    slug: 'Charm%2FPersonalised',
    image: 'https://readdy.ai/api/search-image?query=Gold%20initial%20disc%20pendant%20necklace%20and%20charm%20bracelet%20on%20warm%20background%2C%20personalised%20jewellery%2C%20minimal%20editorial%20photography%2C%20soft%20lighting&width=600&height=600&seq=style-charm&orientation=squarish',
  },
];

export default function ShopByStyle() {
  return (
    <section className="bg-secondary-100 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-500 text-center mb-2">
            Shop by Style
          </h2>
          <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-12 font-label">
            Find your aesthetic — from understated to unmissable
          </p>
        </ScrollReveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {styles.map((style, idx) => (
            <ScrollReveal key={style.name} delay={idx * 70}>
              <Link
                to={`/shop?style=${style.slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer transition-shadow hover:shadow-md"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={style.image}
                    alt={style.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4 text-center">
                  <span className="text-sm md:text-base font-heading font-semibold text-primary-500">
                    {style.name}
                  </span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}